define('modules/UserShopForOrganization/UserShopForOrganizationService',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var userShopForOrganizationKey = "ShopForOrganization";
    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var userShopForOrganization = null;

    function clearUserShopForOrganization() {

        var deferred = $.Deferred();
        $.ajax({
            url: apiUrl + '/api/shopForOrganization/clear/',
            type: 'PUT',
            contentType: 'application/json',
            data: null,
            success: function () {
                clearLocalStorageShopForOrganizationKeys();
                userShopForOrganization = null;
                deferred.resolve(null);
                return;

            },
            error: function () {
                userShopForOrganization = null;
                deferred.reject('An unexpected error has occured when clearing selected shop for organization.');
            }
        });
        return deferred.promise();
    }

    function getUserShopForOrganization() {
        var deferred = $.Deferred();
        //getting userShopForOrganization from localStorage
        userShopForOrganization = Roc.LocalStorageHelper.getStorage(userShopForOrganizationKey);

        if (userShopForOrganization !== null) {
            var parsed = JSON.parse(userShopForOrganization);
            deferred.resolve(parsed);
            return deferred.promise();
        }

        $.ajax({
            url: apiUrl + '/api/shopForOrganization/get/',
            type: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            success: function (response) {
                if (response && response.isSuperUser) {
                    userShopForOrganization = response;
                    if (userShopForOrganization !== null) {

                        Roc.LocalStorageHelper.setStorage(userShopForOrganizationKey, JSON.stringify(response), 300);
                    }
                    deferred.resolve(response);
                    return;
                }
                userShopForOrganization = null;
                deferred.reject(response.errorMessage);
            },
            error: function () {
                userShopForOrganization = null;
                deferred.reject('An unexpected error has occured when getting shop for organization id.');
            }
        });

        return deferred.promise();
    }

    function setShopForOrganization(shopForOrganizationId) {
        var deferred = $.Deferred();
        $.ajax({
            url: apiUrl + '/api/shopForOrganization/set/',
            type: 'PUT',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify({ organizationId: shopForOrganizationId }),
            success: function (response) {
                if (response && response.isSuperUser) {
                    userShopForOrganization = response;
                    Roc.LocalStorageHelper.setStorage(userShopForOrganizationKey, JSON.stringify(response), 300);
                    deferred.resolve(response);
                    return;
                }
                userShopForOrganization = null;
                deferred.reject('An unexpected error has occured when saving shop for organization.');
            },
            error: function () {
                userShopForOrganization = null;
                deferred.reject('An unexpected error has occured when saving shop for organization.');
            }
        });
        return deferred.promise();
    }

    function searchShopForOrganizations(request) {
        var deferred = $.Deferred();
        $.ajax({
            url: apiUrl + '/api/shopForOrganization/search/',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(request),
            success: function (response) {
                if (response) {
                    deferred.resolve(response);
                    return;
                }
                deferred.reject();
            },
            error: function () {
                deferred.reject('An unexpected error has occured when getting allowed shop for organizations .');
            }
        });
        return deferred.promise();
    }

    function searchShopForOrganizationsAll(request) {
        var deferred = $.Deferred();
        $.ajax({
            url: apiUrl + '/api/shopForOrganization/accounts/',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(request),
            success: function (response) {
                if (response) {
                    deferred.resolve(response);
                    return;
                }
                deferred.reject();
            },
            error: function () {
                deferred.reject('An unexpected error has occured when getting allowed shop for organizations .');
            }
        });
        return deferred.promise();
    }

    function clearLocalStorageShopForOrganizationKeys() {
        Roc.LocalStorageHelper.removeStorage(userShopForOrganizationKey);
    }

    var UserShopForOrganizationService = {
        getUserShopForOrganization: getUserShopForOrganization,
        setShopForOrganization: setShopForOrganization,
        clearLocalStorageShopForOrganizationKeys: clearLocalStorageShopForOrganizationKeys,
        searchShopForOrganizations: searchShopForOrganizations,
        clearUserShopForOrganization: clearUserShopForOrganization,
        searchShopForOrganizationsAll: searchShopForOrganizationsAll
    };

    Roc.Logger.debug('UserShopForOrganizationService.js Loaded:', UserShopForOrganizationService);

    return UserShopForOrganizationService;

});
